import React, { Component } from 'react'
import Card from './CardUI';

import img1 from "../../assets/WhatsApp Image 2020-06-03 at 19.08.22.jpeg";
import img2 from "../../assets/WhatsApp Image 2020-06-03 at 19.10.29.jpeg";
import img3 from "../../assets/clay-banks-e6pK_snssSY-unsplash (1) (1).jpg";
import img4 from "../../assets/WhatsApp Image 2020-06-03 at 19.19.55.jpeg";
import img5 from "../../assets/WhatsApp Image 2020-06-03 at 19.29.40.jpeg";
import img6 from "../../assets/WhatsApp Image 2020-06-03 at 19.22.47.jpeg";

export default class Cards extends Component {
    render() {
        return(
            <div className="container-fluid d-flex justify-content-center">
                <div className="row">
                    <div className="col-md-4">
                        <Card imgsrc={img1} title="Add a Surgery Request" description="Operations to be Scheduled" href="/orthopedic/add_surgery_request"/>
                    </div>
                    <div className="col-md-4">
                        <Card imgsrc={img6} title="Surgeries Requests List" description="Awaiting Surgeries" href="/orthopedic/surgeries_requests"/>
                    </div>
                    <div className="col-md-4">
                        <Card imgsrc={img2} title="Surgeons' Shifts" description="Surgical Ward's Surgeons' Shifts" href="/orthopedic/shifts"/>
                    </div>
                    <div className="col-md-4">
                        <Card imgsrc={img3} title="Schedule of Operations" description="Current Schedule" href="/orthopedic/calendar"/>
                    </div>
                    <div className="col-md-4">
                        <Card imgsrc={img4} title="Allocated Rooms" description="<Room, Day>s of Ward" href="/nomatch"/>
                    </div>
                    <div className="col-md-4">
                        <Card imgsrc={img5} title="Edit Priorities" description="Change and Set Priorities" href="/nomatch"/>
                    </div>
                </div>
            </div>
        )
    }
}